export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", max = 180) {
  const clean = stripHtml(value);

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const raw = String(value).trim();

  const match = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/,
  );

  if (!match) return "Date inconnue";

  const [, yyyy, mm, dd, hh, mi] = match;

  if (!hh || !mi) {
    return `${dd}/${mm}/${yyyy}`;
  }

  return `${dd}/${mm}/${yyyy} à ${hh}:${mi}`;
}

export function buildProjetsSearchParams({ q, stateFilter, page, limit }) {
  return {
    q: q?.trim() || undefined,
    is_active:
      stateFilter === "all"
        ? undefined
        : stateFilter === "active"
          ? true
          : false,
    page,
    limit,
    sort: "created_at",
    dir: "DESC",
  };
}

export function normalizeProjetForm(form) {
  return {
    titre: form.titre.trim(),
    description: form.description || "",
    image_projet_url: form.image_projet_url?.trim() || "",
    page_detail_url: form.page_detail_url?.trim() || "",
    is_active: !!form.is_active,
  };
}

export function validateProjetForm(form) {
  const errors = {};

  if (!form.titre?.trim()) {
    errors.titre = "Le titre est obligatoire.";
  }

  return errors;
}

export function getProjetUrlLabel(url = "") {
  const clean = String(url || "").trim();

  if (!clean) return "Aucun lien";

  if (clean.startsWith("http")) return "Lien externe";

  return "Page interne";
}

export function getProjetsStats(items = [], total = 0) {
  const activeOnPage = items.filter((item) => !!item.is_active).length;
  const inactiveOnPage = items.filter((item) => !item.is_active).length;
  const withImageOnPage = items.filter((item) => !!item.image_projet_url).length;
  const withDetailLinkOnPage = items.filter(
    (item) => !!item.page_detail_url,
  ).length;

  return {
    total,
    activeOnPage,
    inactiveOnPage,
    withImageOnPage,
    withDetailLinkOnPage,
  };
}